import VisibilityIcon from '@mui/icons-material/Visibility';
import { useCreatePathWithQuery } from 'hooks/useCreatePathWithQuery';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { useRecordContext, useResourceContext } from 'react-admin';
import { Link, LinkProps } from 'react-router-dom';
import { useContextMenuContext } from 'shared/mui/ContextMenu/context/contextMenuContext';
import {
  ContextMenuButton,
  ContextMenuButtonProps,
} from 'shared/mui/ContextMenu/ContextMenuButton/ContextMenuButton';

export type ContextMenuShowButtonProps = Omit<ContextMenuButtonProps, 'icon' | 'label'> & {
  linkProps?: Partial<LinkProps> & { resource?: string };
};

export const ContextMenuShowButton: React.FC<ContextMenuShowButtonProps> = ({
  linkProps,
  ...restProps
}) => {
  const translate = useTypedTranslate();
  const { createPathWithQuery } = useCreatePathWithQuery();

  const resource = useResourceContext(linkProps);
  const record = useRecordContext(linkProps);
  const { onCloseMenu } = useContextMenuContext();

  const { resource: customResource, ...restLinkProps } = linkProps ?? {};

  return (
    <Link
      style={{ textDecoration: 'none' }}
      to={createPathWithQuery({
        resource: customResource ?? resource,
        id: record?.id ?? record?.['@id'],
        type: 'show',
      })}
      {...restLinkProps}
    >
      <ContextMenuButton
        icon={<VisibilityIcon fontSize="small" />}
        label={translate('app.buttons.show')}
        onClick={onCloseMenu}
        {...restProps}
      />
    </Link>
  );
};
